import { createApi } from '@reduxjs/toolkit/query/react';
import { getRtkConfig } from '@shared/config/index';
import type { CityList } from '@shared/types/delivery';

const deliveryApi = createApi({
	reducerPath: 'deliveryQueries',
	baseQuery: getRtkConfig('/api/v1/delivery/'),
	tagTypes: ['delivery'],

	endpoints: build => ({

		getCities: build.query<CityList, { search?: string }>({
			query: (params) => ({
				params,
				url: 'cdek/city/',
				method: 'get',
			}),
			providesTags: ['delivery'],
		}),

	}),
});

export const {
	useGetCitiesQuery,
} = deliveryApi;

export const deliveryApiReducerPath = deliveryApi.reducerPath;

export const deliveryQueriesReducer = deliveryApi.reducer;

export const deliveryMiddleware = deliveryApi.middleware;
